define('meeting-modal/tab-options/profile-tab',['require','api-access','api-access','web-urls','knockout','filepicker'],function (require) {
    var gotomeetApi = require('api-access').gotomeet;
    var meetingsApi = require('api-access').meetings;
    var webUrls = require('web-urls');

    var ko = require('knockout');
    var filepicker = require('filepicker');
    filepicker.setKey('AJqSc8UQuT0mnTtDxo4BRz');

    var ProfileTab = function (meetingId, submit) {
        var self = this;

        self.goToMeetMeUrl = webUrls.get('gotoMeetMeUrl');

        self.availableThemes = ko.observableArray(['default', 'yellow', 'purple', 'blue', 'green']);
        self.selectedTheme = ko.observable(self.availableThemes()[0]);
        self.name = ko.observable();
        self.userRoomName = ko.observable();
        self.userTitle = ko.observable();
        self.userLocation = ko.observable();
        self.meetMe = ko.observable();
        self.meetingId = ko.observable();
        self.userAvatar = ko.observable();
        self.profileUrl = ko.observable();
        self.userProfileLink = ko.observable().extend({ maxLength: 100, url: true });

        /*
         * inputUrl: matches exactly the user types into the field.
         * oldUrl: the previous string the user types into the field.
         *
         * Since we always want 'http://gotomeet.me/' present in the field,
         * we subscribe to inputUrl and replace the string with oldUrl if 'http://gotomeet.me/' isn't found.
         *
         * delayedUrl: Only the room name. Extracts 'room1' from 'http://gotomeet.me/room1'.
         * delayedUrl will update at a rate limit.
         * Use delayedUrl as the accepted value, not inputUrl or oldUrl.
         */
        self.inputUrl = ko.observable();
        self.oldUrl = ko.observable();
        self.inputUrl.subscribe(function (newUrl) {
            if (newUrl && newUrl.indexOf(self.goToMeetMeUrl + '/') === 0) {
                self.oldUrl(newUrl);
            } else {
                self.inputUrl(self.oldUrl());
            }
        });
        self.delayedUrl = ko.pureComputed(function () {
            if (self.inputUrl()) {
                return self.inputUrl().replace(self.goToMeetMeUrl + '/', '');
            }
            return undefined;
        }).extend({
            rateLimit: {
                method: 'notifyWhenChangesStop',
                timeout: 400
            },
            // TODO Required is glitched here
            required: true,
            urlRegex: true,
            takenG2mmUrl: true
        });

        self.isUrlModified = ko.computed(function () {
            if (self.meetMe() && (typeof self.delayedUrl() !== 'undefined')) {
                return self.meetMe().profileId !== self.delayedUrl();
            }
            return undefined;
        });

        self.isUrlValid = ko.computed(function () {
            return !self.isUrlModified() || (self.delayedUrl.isValid() && !self.delayedUrl.isValidating());
        }).extend({
            validation: {
                validator: function (value) {
                    return value;
                }
            }
        });

        self.showUrlConfirmation = ko.observable(false);

        self.validation = ko.validatedObservable({
            userProfileLink: self.userProfileLink,
            isUrlValid: self.isUrlValid
        });

        self.selectTheme = function (theme) {
            self.selectedTheme(theme);
        };

        self.pickAvatar = function () {
            filepicker.pickAndStore(
                {
                    multiple: false,
                    mimetypes: ['image/*'],
                    container: 'window',
                    services: ['COMPUTER', 'WEBCAM', 'FACEBOOK', 'INSTAGRAM', 'FLICKR']
                },
                { location: 'S3' },
                function (upload) {
                    self.userAvatar(upload[0].url);
                },
                function () {
                    // handle err
                }
            );
        };

        self.cancelUrl = function () {
            self.showUrlConfirmation(false);
            self.inputUrl(self.goToMeetMeUrl + '/' + self.meetMe().profileId);
        };

        self.buildOptions = function () {
            return {
                name: self.name(),
                title: self.userTitle(),
                theme: self.selectedTheme(),
                location: self.userLocation(),
                avatarUrl: self.userAvatar(),
                profileUrl: self.profileUrl(),
                meetingId: self.meetingId(),
                profileId: self.delayedUrl(),
                inputUrl: self.inputUrl()
            };
        };

        self.submit = submit;

        self.activate = function () {
            gotomeetApi.getByUserKey()
                .then(function (meeting) {
                    // get user's settings
                    self.meetMe(meeting);
                    self.meetingId(meeting.meetingId);
                    self.name(meeting.name);
                    self.userTitle(meeting.title);
                    self.userLocation(meeting.location);
                    self.selectedTheme(meeting.theme);
                    self.userAvatar(meeting.avatarUrl);
                    self.profileUrl(meeting.profileUrl);
                    self.inputUrl(self.goToMeetMeUrl + '/' + meeting.profileId);
                });

            meetingsApi.byIdFormatted(meetingId)
                .then(function (meeting) {
                    self.userRoomName(meeting.subject);
                });
        };
    };

    return ProfileTab;
});

